import React from "react";

const CheckboxOnOff = ({
  label,
  name,
  id,
  isChecked,
  onChange,
  disabled = false,
  ...props
}) => {
  const inputId = id || name;
  const containerClass = disabled
    ? "switch-container switch-container--disabled"
    : "switch-container";

  return (
    <div className={containerClass}>
      <label className="switch">
        <input
          id={inputId}
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <span className="slider round"></span>
      </label>
      {label ? (
        <label className="switch-label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
    </div>
  );
};

export default CheckboxOnOff;
